import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33594fa9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view process-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "process-list__header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Process progress viewer")
], -1))
const _hoisted_3 = { class: "process-list__process-list" }
const _hoisted_4 = { class: "process-list__container" }
const _hoisted_5 = { class: "process-list__item-left" }
const _hoisted_6 = { class: "process-list__gfx" }
const _hoisted_7 = { class: "process-list__start" }
const _hoisted_8 = { class: "process-list__id" }
const _hoisted_9 = { class: "process-list__text" }
const _hoisted_10 = { class: "process-list__item-right" }
const _hoisted_11 = { class: "process-list__progress-bar" }
const _hoisted_12 = { class: "process-list__progress-bar-rail" }
const _hoisted_13 = { class: "process-list__progress-percentage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "process-list__item",
            key: item.externalId
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("i", {
                  class: _normalizeClass(["material-icons", item.isFinished ? 'green' : 'blue in-progress'])
                }, _toDisplayString(item.isFinished ? 'check_circle' : 'sync'), 3)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.returnDate(item.created)), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.externalId), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("b", null, _toDisplayString(item.type), 1),
                _createTextVNode(" " + _toDisplayString(item.count) + " users", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "process-list__progress-bar-fill",
                    style: _normalizeStyle({'width': `${item.completion}%`})
                  }, null, 4)
                ]),
                _createElementVNode("span", _hoisted_13, _toDisplayString(item.completion) + "%", 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}